var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35 6.81818C7.66756 6.81818 7.925 7.08274 7.925 7.40909V10.9545C7.925 11.2809 7.66756 11.5455 7.35 11.5455C7.03244 11.5455 6.775 11.2809 6.775 10.9545V7.40909C6.775 7.08274 7.03244 6.81818 7.35 6.81818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.225 7.40909C10.225 7.08274 9.96756 6.81818 9.65 6.81818C9.33244 6.81818 9.075 7.08274 9.075 7.40909V10.9545C9.075 11.2809 9.33244 11.5455 9.65 11.5455C9.96756 11.5455 10.225 11.2809 10.225 10.9545V7.40909Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 3.86364V3.27273C5.625 2.29368 6.39731 1.5 7.35 1.5H9.65C10.6027 1.5 11.375 2.29368 11.375 3.27273V3.86364H13.675C13.9926 3.86364 14.25 4.1282 14.25 4.45455C14.25 4.7809 13.9926 5.04545 13.675 5.04545H13.1V12.7273C13.1 13.7063 12.3277 14.5 11.375 14.5H5.625C4.67231 14.5 3.9 13.7063 3.9 12.7273V5.04545H3.325C3.00744 5.04545 2.75 4.7809 2.75 4.45455C2.75 4.1282 3.00744 3.86364 3.325 3.86364H5.625ZM6.775 3.27273C6.775 2.94638 7.03244 2.68182 7.35 2.68182H9.65C9.96756 2.68182 10.225 2.94638 10.225 3.27273V3.86364H6.775V3.27273ZM11.95 5.04545V12.7273C11.95 13.0536 11.6926 13.3182 11.375 13.3182H5.625C5.30744 13.3182 5.05 13.0536 5.05 12.7273V5.04545H11.95Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDelete);
export default __webpack_public_path__ + "static/media/whiteDelete.0f4ca25166e12f1a6d6f418e11c543ee.svg";
export { ForwardRef as ReactComponent };